export interface IPayment {
  paymentType: string;
  amount: number;
}